export const PHOTO_MAX_EDGE = 1600;
export const PHOTO_JPEG_QUALITY = 0.7;
export const ESTIMATE_PHONE_DISPLAY = '(772) 494-5048';

const PHONE_HELP = `Please call or text us at ${ESTIMATE_PHONE_DISPLAY}.`;

export function scaledPhotoSize(width, height, maxEdge = PHOTO_MAX_EDGE) {
  const safeWidth = Number(width) || 0;
  const safeHeight = Number(height) || 0;
  const longest = Math.max(safeWidth, safeHeight, 1);
  const scale = Math.min(1, maxEdge / longest);
  return {
    width: Math.max(1, Math.round(safeWidth * scale) || 1),
    height: Math.max(1, Math.round(safeHeight * scale) || 1),
  };
}

function issueText(issue) {
  if (!issue) return '';
  if (typeof issue === 'string') return issue;
  const message = issue.msg || issue.message;
  if (typeof message !== 'string' || !message.trim()) return '';
  const location = Array.isArray(issue.loc)
    ? issue.loc.filter((part) => part !== 'body' && part !== 'query' && part !== 'path').join('.')
    : '';
  return location ? `${location}: ${message}` : message;
}

export function formatEstimateErrorDetail(detail) {
  if (detail == null || detail === '') return '';
  if (typeof detail === 'string') return detail;
  if (typeof detail === 'number' || typeof detail === 'boolean') return String(detail);
  if (Array.isArray(detail)) {
    return detail.map(issueText).filter(Boolean).join('; ');
  }
  if (typeof detail === 'object') {
    if (typeof detail.msg === 'string') return issueText(detail);
    if (typeof detail.message === 'string') return detail.message;
    if (detail.detail != null) return formatEstimateErrorDetail(detail.detail);
    try {
      return JSON.stringify(detail);
    } catch {
      return '';
    }
  }
  return String(detail);
}

export function estimateFailureMessage(detail) {
  const readable = formatEstimateErrorDetail(detail).trim();
  if (!readable) return `We couldn't submit your request. ${PHONE_HELP}`;
  if (readable.includes(ESTIMATE_PHONE_DISPLAY)) return readable;
  const separator = /[.!?]$/.test(readable) ? ' ' : '. ';
  return `${readable}${separator}${PHONE_HELP}`;
}

export function compressImageFile(file, { maxEdge = PHOTO_MAX_EDGE, quality = PHOTO_JPEG_QUALITY, imageFactory, canvasFactory } = {}) {
  return new Promise((resolve, reject) => {
    if (!file || (file.type && !String(file.type).startsWith('image/'))) {
      reject(new Error('Please choose an image file.'));
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    const image = imageFactory ? imageFactory() : new Image();
    image.onload = () => {
      try {
      const { width, height } = scaledPhotoSize(image.width, image.height, maxEdge);
      const canvas = canvasFactory ? canvasFactory() : document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      if (!context) {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Could not process that photo. Please try a different image.'));
        return;
      }
      context.drawImage(image, 0, 0, width, height);
      const dataUrl = canvas.toDataURL('image/jpeg', quality);
      URL.revokeObjectURL(objectUrl);
      const baseName = String(file.name || 'photo').replace(/\.[^.]+$/, '') || 'photo';
      resolve({ dataUrl, name: `${baseName}.jpg` });
      } catch (error) {URL.revokeObjectURL(objectUrl); reject(error);}
    };
    image.onerror = image.onabort = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Could not read that photo. Please try a different image.'));
    };
    image.src = objectUrl;
  });
}
